(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tonzi-black-november-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tonzi-black-november-badge')) {
    customElements.define('tonzi-black-november-badge', class extends HTMLElement {
      connectedCallback() {
        this.updateVisibility();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
      }
      updateVisibility() {
        clearTimeout(this.timer);
        const now = Date.now();
        const start = Date.parse(this.dataset.start);
        const end = Date.parse(this.dataset.end);
        this.hidden = !((now >= start && now < end));
        const boundary = now < start ? start : end;
        if (boundary > now) {
          this.timer = setTimeout(() => this.updateVisibility(), Math.min(boundary - now, 3600000));
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tonzi-campaign-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tonzi-campaign-countdown')) {
  customElements.define('tonzi-campaign-countdown', class extends HTMLElement {
    connectedCallback() {
      this.start = Date.parse(this.dataset.start);
      this.end = Date.parse(this.dataset.end);
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const now = Date.now();
      const valid = Number.isFinite(this.start) && Number.isFinite(this.end) && this.end > this.start;
      const active = valid && now >= this.start && now < this.end;
      const preview = false;
      this.hidden = !valid || (!active && !preview);
      if (this.hidden) return;
      const seconds = Math.max(0, Math.ceil((this.end - (now < this.start ? this.start : now)) / 1000));
      const values = {days:Math.floor(seconds/86400),hours:Math.floor(seconds%86400/3600),minutes:Math.floor(seconds%3600/60),seconds:seconds%60};
      for (const [unit,value] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2,'0');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tonzi-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tonzi-product-video')) {
    customElements.define('tonzi-product-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        this.gallery = this.closest('product-gallery');
        this.visible = false;
        this.manualPause = false;
        this.manualStart = false;
        this.pending = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.video.muted = true;
        this.video.controls = false;
        this.button.hidden = false;
        const updateButton = () => {
          this.toggleAttribute('playing', !this.video.paused);
          this.button.setAttribute('aria-label', this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        };
        this.video.addEventListener('play', () => {
          if (!this.visible || document.hidden || this.manualPause) this.video.pause();
          updateButton();
        }, options);
        this.video.addEventListener('pause', updateButton, options);
        this.video.addEventListener('click', (event) => {
          if (this.video.controls) return;
          event.stopPropagation();
          this.button.click();
        }, options);
        this.button.addEventListener('click', (event) => {
          event.stopPropagation();
          if (this.video.paused) {
            this.manualPause = false;
            this.manualStart = true;
            this.play();
          } else {
            this.manualPause = true;
            this.pause();
          }
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5;
          this.syncPlayback();
        }, { threshold: [0, 0.5, 1] });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.motion.addEventListener('change', () => this.syncPlayback(), options);
        this.gallery?.addEventListener('carousel:settle', () => requestAnimationFrame(() => this.syncPlayback()), options);
        if (this.gallery && !this.gallery.tonziFilterInstalled) {
          this.gallery.tonziFilterInstalled = true;
          const preserveDuplicates = event => {
            if (!event.detail?.filteredIndexes) return;
            Array.from(event.target.children).forEach((item, index) => {
              if (item.hasAttribute('data-tonzi-duplicate') && !event.detail.filteredIndexes.includes(index)) event.detail.filteredIndexes.push(index);
            });
          };
          this.gallery.addEventListener('carousel:filter', preserveDuplicates, true);
          this.gallery.addEventListener('control:filter', preserveDuplicates, true);
        }
        updateButton();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.video?.pause();
      }
      syncPlayback() {
        if (this.visible && !document.hidden && !this.manualPause && (!this.motion.matches || this.manualStart)) this.play();
        else this.pause();
      }
      async play() {
        if (!this.video || this.pending || !this.visible || document.hidden || this.manualPause || (this.motion.matches && !this.manualStart)) return;
        this.pending = true;
        try {
          await this.video.play();
          if (!this.visible || document.hidden || this.manualPause) this.video.pause();
        } catch (error) {
          if (error.name !== 'AbortError') this.video.controls = true;
        } finally {
          this.pending = false;
        }
      }
      pause() { this.video?.pause(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
